import { defineComponent, onMounted, computed } from "vue";
import store from "@/store";
import { HubConnectionBuilder } from "@microsoft/signalr";
import i18n from "@/i18n";

import { signalrURL } from "@/extensions/extra";
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';;
import { getAuthSessionManager } from "@/utils/authSessionManager";

const SHARED_LOGOUT_MARKER_APPLIED_MESSAGE = "Your session ended in another VaultN app.";

export default defineComponent({
  name: "SignalR",

  setup() {
    const $q = useQuasar();
    const ownerGuid = computed(() => store.state.ownerGuid);
    const userId = computed(() => store.state.userId);

    onMounted(() => {
      const apiUrl = signalrURL;
      const connection = new HubConnectionBuilder()
        .withUrl(apiUrl + "hubs/notification", {
          accessTokenFactory: async () => {
            if (await getAuthSessionManager().applySharedLogoutMarkerIfNeeded()) {
              throw new Error(SHARED_LOGOUT_MARKER_APPLIED_MESSAGE);
            }

            return store.state.token.replace("Bearer ", "");
          },
        })
        .withAutomaticReconnect()
        .build();
      // @ts-ignore
      connection
        .start()
        .then(() => {
          connection.send("attachToGroup", ownerGuid.value);
        })
        .catch((error: any) => {
          console.warn("SignalR connection failed:", error);
        });
      connection.on("keybykeyreportupdate", (data: any) => {
        if (data.ownerId == userId.value && data.message != null) {
          $q.notify({
            message: i18n.global
              .t("reportIsReadyToDownload.definition")
              .toString(),
            color: "blue",
            position: "bottom-right",
            icon: "information",
            timeout: 8000,
            group: "report-created-group",
            actions: [
              {
                label: i18n.global.t("download.definition").toString(),
                color: "white",
                handler: () => {
                  window.open(data.message, "_self");
                },
              },
            ],
          });
          store.commit("setIsReportReady", true);
        }
      });
      /*connection.on("pricelistgenerationupdate", (data: any) => {
        console.log("pricelistgenerationupdate");
        console.log(data);
        if (data.sender == ownerGuid.value && data.fileUrl != null) {
          $q.notify({
            message: i18n.global.t("priceListIsReadyToDownload.definition").toString(),
            color: "blue",
            position: "bottom-right",
            icon: "information",
            timeout: 8000,
            group: 'list-all-products-group',
            actions: [
              {
                label: i18n.global.t("download.detail").toString(), color: "white", handler: () => {
                  window.open(data.fileUrl, '_self');
                }
              }
            ]
          });
          store.commit('setIsReportReady', true);
        }
      });*/
    });
    return {};
  },
});
